import { createRoot } from "react-dom/client";
import RmaView from "../views/RmaView";

const RmaPage: React.FC = () => {
    return <div className="px-5 mx-5">
        <RmaView />
    </div>;
};

const RmaPageId = document.getElementById("rma-form-page");
const root = RmaPageId && createRoot(RmaPageId as HTMLElement);
root && root.render(<RmaPage />);
